import styled from 'styled-components/native';
import LinearGradient from 'react-native-linear-gradient';
import FontAwesome5 from 'react-native-vector-icons/FontAwesome5';
import {RFValue} from 'react-native-responsive-fontsize';
import FastImage from 'react-native-fast-image';
import {isIphoneX} from 'react-native-iphone-screen-helper';
import {Dimensions, Platform} from 'react-native';

let spacing = 0;
const win = Dimensions.get('screen');
if (win.width <= 360) {
  spacing = RFValue(0);
} else {
  spacing = RFValue(12);
}

export const PromoBanner = styled.TouchableOpacity`
  margin: 0 -24px;
  margin-top: ${Platform.OS === 'ios' && !isIphoneX()
    ? RFValue(10)
    : Platform.OS === 'android'
    ? -0
    : 0}px;
  overflow: hidden;
`;

export const PromoBannerBackground = styled(LinearGradient).attrs(
  ({theme}) => ({
    colors: theme.colors.promo_marquee_bg,
    start: {x: 0, y: 0.2},
    end: {x: 1, y: 0.2},
  }),
)`
  width: 100%;
  padding: ${RFValue(2)}px ${RFValue(8)}px;
`;

export const PromoIcon = styled(FontAwesome5)`
  color: ${({theme}) => theme.colors.shape};
`;

export const PromoContainer = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;
  gap: ${RFValue(6)}px;
`;

export const PromoBannerText = styled.Text.attrs({
  numberOfLines: 1,
  ellipsizeMode: 'clip',
  allowFontScaling: false,
})`
  color: ${({theme}) => theme.colors.shape};
  font-size: ${RFValue(9)}px;
  font-family: ${({theme}) => theme.fonts.bold};
  text-transform: uppercase;
  margin-right: ${RFValue(28)}px;
`;

export const ShieldIcon = styled(FastImage)`
  width: ${RFValue(16)}px;
  height: ${RFValue(16)}px;
`;

export const MoneyIcon = styled(FastImage)`
  width: ${RFValue(16)}px;
  height: ${RFValue(16)}px;
`;
